@if (displayName()) {
<button mat-icon-button [matMenuTriggerFor]="menu" [matTooltip]="displayName()" class="initials">
    {{initials()}}
</button>
}

<mat-menu #menu="matMenu" xPosition="before">
    @if (displayName()) {
        <div  class="logout-menu-container">
            <button  matButton="tonal" (click)="logout()" class="accent">
                <mat-icon>exit_to_app</mat-icon> 
                {{ 'app.logout' | translate }} {{ displayName() }}
            </button>
        </div>
    }
</mat-menu>